export const getVisibleFields = (state, profileType) =>
  state.profileDetailsFieldConfiguration[profileType]?.visibleFields || []

export const getAdminVisibleFields = (state, profileType) =>
  state.profileDetailsFieldConfiguration[profileType]?.adminVisibleFields || []
